var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6807 9.639L13.3823 6.89891L4.65617 1.92468C4.07784 1.60777 3.53606 1.56329 3.06097 1.90986L10.6807 9.639ZM13.8427 12.847L16.6512 11.2449C17.1994 10.9335 17.5 10.4924 17.5 10.0032C17.5 9.51483 17.1994 9.07282 16.6522 8.76147L14.1095 7.31312L11.2471 10.2154L13.8427 12.847V12.847ZM2.59136 2.58353C2.53289 2.76608 2.5 2.96994 2.5 3.19326V16.8196C2.5 17.1726 2.57675 17.4766 2.71562 17.7184L10.1133 10.2144L2.59136 2.58353ZM10.6807 10.789L3.3241 18.2512C3.46479 18.3059 3.61646 18.3346 3.77634 18.3346C4.0614 18.3346 4.35833 18.2494 4.66074 18.0789L13.1164 13.2631L10.6807 10.789V10.789Z",
    fill: "#C0D7D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidApp);
export default __webpack_public_path__ + "static/media/AndroidApp.6ef9034b651ab662ed2c369020353891.svg";
export { ForwardRef as ReactComponent };